import React, { useState, useEffect } from 'react';
import './VoiceMemos.css';
import SimpleAudioPlayer from './SimpleAudioPlayer';

function VoiceMemos({ onGoHome }) {
  const [selectedMemo, setSelectedMemo] = useState(null);
  const [showPlayer, setShowPlayer] = useState(false);
  
  // Handle escape key for closing player or going home
  useEffect(() => {
    const handleKeyDown = (event) => {
      if (event.key === 'Escape') {
        if (showPlayer) {
          closeAudioPlayer();
        } else {
          onGoHome();
        }
      }
    };

    window.addEventListener('keydown', handleKeyDown);
    return () => window.removeEventListener('keydown', handleKeyDown);
  }, [showPlayer, onGoHome]);
  // 
  // Voice memos data with paths to actual audio files that exist in the directory
  
  const memos = [
    { id: 1, title: "Улсын их Дэлгүүр", location: "ulaanbaatar, mongolia", file: "/assets/voice-memos/Улсын их Дэлгүүр.m4a" },
    { id: 2, title: "Наадамчдын зам", location: "ulaanbaatar, mongolia", file: "/assets/voice-memos/Наадамчдын зам.m4a" },
    { id: 3, title: "Beijing INTL", location: "beijing, china", file: "/assets/voice-memos/Beijing INTL.m4a"},
    { id: 4, title: "Peace Avenue", location: "paris, france", file: "/assets/voice-memos/Peace Avenue.m4a" },
    { id: 5, title: "Petchyindee Kingdom", location: "bangkok, thailand", file: "/assets/voice-memos/Petchyindee Kingdom.m4a" },
    { id: 6, title: "Washenjoy", location: "bangkok, thailand", file: "/assets/voice-memos/Washenjoy.m4a" },
    { id: 7, title: "Zanabazar Museum of Fine Art", location: "ulaanbaatar, mongolia", file: "/assets/voice-memos/Zanabazar Museum of FIne Art.m4a" },
    { id: 8, title: "Avenue Charles de Gaulle", location: "paris, france", file: "/assets/voice-memos/Avenue Charles de Gaulle.m4a" },
    { id: 9, title: "Basic-Fit", location: "toronto, canada", file: "/assets/voice-memos/Basic-Fit.m4a" },
    { id: 10, title: "Boulevard de Port-Royal", location: "paris, france", file: "/assets/voice-memos/Boulevard de Port-Royal.m4a" },
    { id: 11, title: "Chatuchak Park", location: "bangkok, thailand", file: "/assets/voice-memos/Chatuchak Park.m4a" },
    { id: 12, title: "Dionysiou tou Areopagitou", location: "athens, greece", file: "/assets/voice-memos/Dionysiou tou Areopagitou.m4a" },
    { id: 13, title: "Esplanade André Tollet", location: "paris, france", file: "/assets/voice-memos/Esplanade André Tollet.m4a" },
    { id: 14, title: "Hotel Indigo NYC", location: "nyc, usa", file: "/assets/voice-memos/Hotel Indigo Lower East Side New York.m4a" },
    { id: 15, title: "La Gare Le Gore", location: "paris, france", file: "/assets/voice-memos/La Gare Le Gore.m4a" },
    { id: 16, title: "McDonald's", location: "paris, france", file: "/assets/voice-memos/McDonald's.m4a" },
    { id: 17, title: "New Recording 5", location:"bangkok, thailand", file:"/assets/voice-memos/New Recording 5.m4a"},
    { id: 18, title: "Place de la Nation 2", location: "paris, france", file: "/assets/voice-memos/Place de la Nation 2.m4a" },
    { id: 19, title: "Place de la Nation", location: "paris, france", file: "/assets/voice-memos/Place de la Nation.m4a" },
    { id: 20, title: "QEW", location: "toronto, canada", file: "/assets/voice-memos/QEW.m4a" },
    { id: 21, title: "Upkeep Club 2", location: "toronto, canada", file: "/assets/voice-memos/Upkeep Club 2.m4a" },
    { id: 22, title: "Walton St", location: "nyc, usa", file: "/assets/voice-memos/Walton St.m4a" },
    { id: 23, title: "Blue Jays Way", location: "toronto, canada", file: "/assets/voice-memos/20 Blue Jays Way.m4a" },
    { id: 24, title: "Art Works Art School", location: "toronto, canada", file: "/assets/voice-memos/Art Works Art School.m4a" },
    { id: 25, title: "Chiang Mai Gate 3 Nightmarket", location:"chiang mai, thailand", file:"/assets/voice-memos/Chiang Mai Gate 3 Nightmarket.m4a"},
    { id: 26, title: "Smile Inn 3", location:"bangkok, thailand", file:"/assets/voice-memos/Smile Inn 3 SHANDAR FLIP.m4a"},
    { id: 27, title: "Charoenphon Bridge", location:"bangkok, thailand", file:"/assets/voice-memos/Charoenphon Bridge.m4a"},
    { id: 28, title:"AIS eSports Studio", location:"bangkok, thailand", file:"/assets/voice-memos/AIS eSports Studio.m4a"},
    
  ];

  const openAudioPlayer = (memo) => {
    setSelectedMemo(memo);
    setShowPlayer(true);
  };

  const closeAudioPlayer = () => {
    setShowPlayer(false);
  };

  return (
    <div style={{ fontFamily: 'serif', maxWidth: '100%', margin: '0 auto', padding: '5px' }}>
      <table width="100%" border="0" cellSpacing="0" cellPadding="0">
        <tbody>
          <tr>
            <td>
              <button onClick={onGoHome} style={{background: 'none', border: 'none', padding: 0, color: '#0000FF', textDecoration: 'underline', cursor: 'pointer', fontFamily: 'serif', fontSize: '16px'}} title="Press Escape or click to go back">Back</button>
            </td>
          </tr>
          <tr>
            <td align="center">
              <h1>Audio Recordings</h1>
              <hr style={{border: 'none', height: '1px', backgroundColor: '#000'}} />
            </td>
          </tr>
          <tr>
            <td>
              <table width="100%" border="1" cellSpacing="0" cellPadding="2" style={{ borderCollapse: 'collapse', tableLayout: 'fixed' }}>
                <thead>
                  <tr bgcolor="#EEEEEE">
                    <th width="70%">Title</th>
                    <th width="30%">Location Data</th>
                  </tr>
                </thead>
                <tbody>
                  {memos.map((memo) => (
                    <tr key={memo.id}>
                      <td>
                        <button 
                          onClick={() => openAudioPlayer(memo)}
                          title={`Play: ${memo.title}`}
                          style={{background: 'none', border: 'none', padding: 0, color: '#0000FF', textDecoration: 'underline', cursor: 'pointer', fontFamily: 'serif', textAlign: 'left', width: '100%', fontSize: 'inherit'}}
                        >
                          {memo.title}
                        </button>
                      </td>
                      <td align="center">{memo.location}</td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </td>
          </tr>
        </tbody>
      </table>

      {/* Retro Audio Player */}
      {showPlayer && selectedMemo && (
        <SimpleAudioPlayer 
          audioFile={selectedMemo.file} 
          title={selectedMemo.title} 
          onClose={closeAudioPlayer}
        />
      )}
    </div>
  );
}

export default VoiceMemos;
